import { BroadcastChannel, createLeaderElection } from 'broadcast-channel';

import { IAuthState } from 'api/auth/types';

export enum BROADCAST_CHANNEL_APP_ACTION {
  LOGIN = 'login',
  LOGOUT = 'logout',
  REQUEST_NOTIFICATION_COUNT = 'request_notification_count',
  UPDATE_NOTIFICATION_COUNT = 'update_notification_count',
}

type TokenMessage =
  | { payload: IAuthState; type: BROADCAST_CHANNEL_APP_ACTION.LOGIN }
  | { payload: number; type: BROADCAST_CHANNEL_APP_ACTION.UPDATE_NOTIFICATION_COUNT }
  | { type: BROADCAST_CHANNEL_APP_ACTION.LOGOUT }
  | { type: BROADCAST_CHANNEL_APP_ACTION.REQUEST_NOTIFICATION_COUNT };

const channel = new BroadcastChannel<TokenMessage>('merchant-portal');

const leaderTabElector = createLeaderElection(channel);

export { channel, leaderTabElector };
